import {
  Directive,
  EventEmitter,
  Output,
  ElementRef,
} from '@angular/core';

@Directive({
  selector: '[wizresize]'
})
export class WizResizeDirective {

  @Output() resized = new EventEmitter<DOMRectReadOnly>();

private observer!: ResizeObserver;

  constructor(private el: ElementRef) {}

  ngAfterViewInit() {
    this.observer = new ResizeObserver(entries => {
      this.resized.emit(entries[0].contentRect);
    });

    this.observer.observe(this.el.nativeElement);
  }

  ngOnDestroy() {
    this.observer?.disconnect();
  }
}
